/**
 * Funcion que genera el listado de paginas permitidas para ser cambiadas en el tracking
 */
export function generatePagination(props) {
  const { page, perPage, total = 0, pageNumbersToShow = 3 } = props;
  // Obtenemos el número de página actual y el número de elementos por página
  const currentPage = page;
  const pageSize = Number(perPage);

  // Si no hay elementos en la data, no necesitamos la paginación, retornamos vacío
  if (!total) {
    return [];
  }

  // Calculamos el número total de páginas según el total de elementos y el tamaño de página
  const lastPageNumber = Math.ceil(total / pageSize);

  // Aseguramos que la página actual no sea mayor que el número total de páginas
  const currentPageNumber = currentPage <= lastPageNumber ? currentPage : lastPageNumber;

  // Calculamos cuántas páginas mostrar antes y después de la página actual
  const maxPagesBeforeCurrentPage = Math.floor(pageNumbersToShow / 2);
  const maxPagesAfterCurrentPage = Math.ceil(pageNumbersToShow / 2) - 1;

  // Inicializamos las variables de inicio y fin para el rango de páginas a mostrar
  let startPage = 1;
  let endPage = lastPageNumber;

  // Si solo hay una página, no necesitamos mostrar paginación, así que retornamos vacío
  if (lastPageNumber <= 1) {
    return [];
  }

  // Calculamos el rango de páginas a mostrar alrededor de la página actual
  if (currentPageNumber <= maxPagesBeforeCurrentPage) {
    // Si estamos en el inicio, mostramos las primeras "pageNumbersToShow" páginas
    startPage = 1;
    endPage = pageNumbersToShow;
  } else if (currentPageNumber + maxPagesAfterCurrentPage >= lastPageNumber) {
    // Si estamos en el final, mostramos las últimas "pageNumbersToShow" páginas
    startPage = lastPageNumber - pageNumbersToShow + 1;
  } else {
    // Si estamos en el medio, mostramos las páginas antes y después de la página actual
    startPage = currentPageNumber - maxPagesBeforeCurrentPage;
    endPage = currentPageNumber + maxPagesAfterCurrentPage;
  }

  // Creamos un array con los números de página dentro del rango calculado
  const pageNumbersRange = Array.from({ length: endPage + 1 - startPage }, (_, index) => startPage + index);

  let pageNumbers = pageNumbersRange
    .filter((pageNumber) => pageNumber <= lastPageNumber && pageNumber > 0)
    .map((pageNumber) => ({
      label: pageNumber,
      isActive: pageNumber === currentPageNumber,
    }));

  // Añadimos "..." o números adicionales al inicio del array si es necesario
  if (pageNumbers[0]?.label > 1) {
    if (pageNumbers[0]?.label <= 2) {
      // Si hay solo una página de diferencia, añadimos el número 1
      pageNumbers = [{ label: 1, isActive: false }, ...pageNumbers];
    } else {
      // Si hay más de una página de diferencia, añadimos "..." o el número 2
      const ellipsis = pageNumbers[0]?.label > 2 ? "..." : 2;
      pageNumbers = [{ label: 1, isActive: false }, { label: ellipsis, isActive: false }, ...pageNumbers];
    }
  }

  // Añadimos "..." o números adicionales al final del array si es necesario
  if (pageNumbers[pageNumbers.length - 1]?.label !== lastPageNumber) {
    if (pageNumbers[pageNumbers.length - 1]?.label === lastPageNumber - 1) {
      // Si hay solo una página de diferencia, añadimos el número lastPageNumber
      pageNumbers = [...pageNumbers, { label: lastPageNumber, isActive: false }];
    } else {
      // Si hay más de una página de diferencia, añadimos "..." o el número lastPageNumber - 1
      const ellipsis = pageNumbers[pageNumbers.length - 1]?.label < lastPageNumber - 2 ? "..." : lastPageNumber - 1;
      pageNumbers = [
        ...pageNumbers,
        { label: ellipsis, isActive: false, isDisabled: true },
        { label: lastPageNumber, isActive: false },
      ];
    }
  }
  // Retornamos el array de números de página generado
  return pageNumbers;
};
